"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ExcelFile = require("./ExcelPlugin/components/ExcelFile");

var _ExcelFile2 = _interopRequireDefault(_ExcelFile);

var _ExcelSheet = require("./ExcelPlugin/elements/ExcelSheet");

var _ExcelSheet2 = _interopRequireDefault(_ExcelSheet);

var _ExcelColumn = require("./ExcelPlugin/elements/ExcelColumn");

var _ExcelColumn2 = _interopRequireDefault(_ExcelColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_ExcelFile2.default.ExcelSheet = _ExcelSheet2.default;
_ExcelFile2.default.ExcelColumn = _ExcelColumn2.default;

var ReactExport = {
    ExcelFile: _ExcelFile2.default
};

exports.default = ReactExport;

exports.modules = {
    ExcelFile: _ExcelFile2.default,
    ExcelSheet: _ExcelSheet2.default,
    ExcelColumn: _ExcelColumn2.default
};


//////////////////
// WEBPACK FOOTER
// ./~/react-data-export/dist/index.js
// module id = 8978
// module chunks = 2